/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Generic pricing information (HT, tax, TTC)
 * @export
 * @interface PricingDto
 */
export interface PricingDto {
    /**
     * 
     * @type {number}
     * @memberof PricingDto
     */
    amountExclTax: number;
    /**
     * 
     * @type {number}
     * @memberof PricingDto
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof PricingDto
     */
    amountInclTax: number;
}

/**
 * Check if a given object implements the PricingDto interface.
 */
export function instanceOfPricingDto(value: object): value is PricingDto {
    if (!('amountExclTax' in value) || value['amountExclTax'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('amountInclTax' in value) || value['amountInclTax'] === undefined) return false;
    return true;
}

export function PricingDtoFromJSON(json: any): PricingDto {
    return PricingDtoFromJSONTyped(json, false);
}

export function PricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amountExclTax': json['amountExclTax'],
        'tax': json['tax'],
        'amountInclTax': json['amountInclTax'],
    };
}

export function PricingDtoToJSON(json: any): PricingDto {
    return PricingDtoToJSONTyped(json, false);
}

export function PricingDtoToJSONTyped(value?: PricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountExclTax': value['amountExclTax'],
        'tax': value['tax'],
        'amountInclTax': value['amountInclTax'],
    };
}

